<ng-template #loadingGeneral>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>

</ng-template>

<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>


<div fxLayout="column">

  <ng-container *ngIf="componentUsageError">
    <h2 class="color-warn"> Error: <br>{{ componentUsageError }}</h2>
  </ng-container>


  <ng-container *ngIf="dataSource; else loadingGeneral">

    <div class="w-100 mb-1" fxLayout="row" fxLayoutAlign="center center" *ngIf="!embeddedLayout">

      <mat-form-field *ngIf="dataSource.data.length > 1" class="mb-0">
        <mat-label>Search</mat-label>
        <input #input (keyup)="applyFilters(input.value)" matInput placeholder="">
      </mat-form-field>

      <mat-form-field class="mb-0 ml-2_5" fxFlex="30">
        <mat-label>Filter permissions</mat-label>
        <input
          #permInput
          matInput
          placeholder="Write a permission and press Enter"
          (keyup.enter)="addPermissionFilter(permInput.value); permInput.value='';">

      </mat-form-field>


      <span fxFlex></span>
      <button (click)="createUser()" color="primary" mat-button>New User</button>
    </div>

    <!-- chips -->
    <div class="mb-2_5" *ngIf="permissionFilters.length">
      <mat-chip-set>
        <mat-chip
          *ngFor="let perm of permissionFilters"
          color="primary"
          style="text-transform: uppercase"
          (removed)="removePermissionFilter(perm)">
          {{ perm }}
          <button matChipRemove>
            <mat-icon>close</mat-icon>
          </button>
        </mat-chip>
      </mat-chip-set>
    </div>

    <mat-progress-bar *ngIf="loading" class="center" mode="indeterminate"></mat-progress-bar>
    <table (matSortChange)="doSortUsers($event)" [dataSource]="dataSource" class="w-100 mat-elevation-z2"
           mat-table
           matSort>

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container matColumnDef="id">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
        <td *matCellDef="let element" mat-cell> {{ element.id }}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="firstName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>First Name</th>
        <td *matCellDef="let element" mat-cell> {{ element.firstName }}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="lastName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Last Name</th>
        <td *matCellDef="let element" mat-cell> {{ element.lastName }}</td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Email</th>
        <td *matCellDef="let element" mat-cell> {{ element.email }}</td>
      </ng-container>

      <!-- Phone Column -->
      <ng-container matColumnDef="phone">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Phone</th>
        <td *matCellDef="let element" mat-cell> {{ element.phone }}</td>
      </ng-container>

      <!-- Enabled Column -->
      <ng-container matColumnDef="enabled">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Enabled</th>
        <td *matCellDef="let element" mat-cell>
          <mat-icon class="correct-color" *ngIf="element.enabled">check_circle</mat-icon>
          <mat-icon class="error-color" *ngIf="!element.enabled">cancel</mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Company</th>
        <td mat-cell *matCellDef="let element">
          {{ element.company?.companyName || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
        <td mat-cell *matCellDef="let element">
          {{ element.address || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="permissions">
        <th mat-header-cell *matHeaderCellDef>Permissions</th>

        <td mat-cell *matCellDef="let element" class="w-max-10-vw">
          <mat-chip-set>
            <mat-chip *ngFor="let perm of element.permissions" color="warn" class="" [disableRipple]="true">
              {{ perm.name }}
            </mat-chip>
          </mat-chip-set>
        </td>
      </ng-container>

      <ng-container matColumnDef="m2m">
        <th mat-header-cell *matHeaderCellDef>M2M</th>

        <td mat-cell *matCellDef="let element" class="w-max-10-vw">
          <ng-container *ngIf="hasPermission(element, 'tester') && element.id !== loggedUser.id">
            <button (click)="changeUserM2MHabilitation(element)"
                    *awIsInAnyRole="['admin', 'customer']"
                    [disabled]="disabled"
                    mat-icon-button
                    [matTooltip]="element.m2mEnabled ? 'Disable M2M user access' : 'Enable M2M user access'">
              <mat-icon [color]="element.m2mEnabled ? 'primary' : 'accent'">compare_arrows</mat-icon>
            </button>
          </ng-container>
        </td>
      </ng-container>


      <!-- Action -->
      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let element" mat-cell>
          <ng-container *ngIf="!disabledItemId.includes(element.id); else loadingItem">
            <button (click)="details(element)" *ngIf="type == 'all' || detailsAction.enabled"
                    [disabled]="disabled" mat-icon-button matTooltip="Show details">
              <mat-icon>visibility</mat-icon>
            </button>
            <button (click)="editUser(element)" *ngIf="type == 'all'"
                    [disabled]="disabled" mat-icon-button matTooltip="Edit user">
              <mat-icon>edit</mat-icon>
            </button>
            <button (click)="editPermissions(element)"
                    *ngIf="type == 'all' && (hasPermission(loggedUser, 'admin') || hasPermission(loggedUser, 'customer'))"
                    [disabled]="disabled"
                    mat-icon-button matTooltip="Edit user permissions">
              <mat-icon>admin_panel_settings</mat-icon>
            </button>
            <ng-container *ngIf="element.enabled && element.id !== loggedUser.id">
              <button (click)="changeUserHabilitation(element)"
                      *ngIf="type == 'all' && hasPermission(loggedUser, 'admin')"
                      [disabled]="disabled"
                      mat-icon-button matTooltip="Disable user">
                <mat-icon color="primary">toggle_on</mat-icon>
              </button>
            </ng-container>
            <ng-container *ngIf="!element.enabled && element.id !== loggedUser.id">
              <button (click)="changeUserHabilitation(element)"
                      *ngIf="type == 'all' && hasPermission(loggedUser, 'admin')"
                      [disabled]="disabled"
                      mat-icon-button matTooltip="Enable user">
                <mat-icon>toggle_off</mat-icon>
              </button>
            </ng-container>


            <button (click)="deleteUser(element)"
                    *ngIf="element.id !== loggedUser.id && (type == 'all' || deleteAction.enabled) && (hasPermission(loggedUser, 'admin') || (hasPermission(loggedUser, 'customer')))"
                    [disabled]="disabled"
                    mat-icon-button
                    matTooltip="Delete user">
              <mat-icon>delete</mat-icon>
            </button>

          </ng-container>
        </td>
      </ng-container>


      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns:  displayedColumns" mat-row></tr>

      <tr *matNoDataRow class="mat-row">
        <td [colSpan]="displayedColumns.length" class="mat-cell text-center">No users found</td>
      </tr>

    </table>
  </ng-container>

  <mat-paginator #paginatorUsers [fxShow]="dataSource && dataSource.data.length > 10" [pageSizeOptions]="[5, 10, 20]"
                 [pageSize]="10" class="mat-elevation-z1" showFirstLastButtons></mat-paginator>
</div>
